import { customerOptionSchema } from '@sophocles/entities/CustomerOption';
import { customerPreferenceSchema } from '@sophocles/entities/CustomerPreference';
import { Record } from 'immutable';
import { schema } from 'normalizr';

export const Customer = new Record({
  id: null,
  billing_account_id: null,
  name: 'NO NAME CUSTOMER',
  description: '',
  website: '',
  is_prospect: false,
  third_parties: [],
  customers_managed: [],
  options: null,
  logo: null,
  preferences: {},
  is_billboard: true,
  customer_type: null,
});

export const customerSchema = new schema.Entity('customers', {
  preferences: customerPreferenceSchema,
  options: customerOptionSchema,
});
